const URL = {
    LOGIN:'/hotel/oauth/token',                                                      //登录
    GET_USER_INFO:'/hotel/auth/sysUser/getCurrentUser',                              //获取当前用户信息
    MODIFY_PASSWORD:'/hotel/auth/sysUser/modifyPassword',                            //修改密码
    UPLOAD_IMG:'/hotel/auth/img/upload',                                             //上传图片
    REGISTER:'/hotel/auth/sysUser/register',                                         //注册
    GET_CODE:'/hotel/auth/sysUser/getCode',                                          //获取验证码

    USER_LIST:'/hotel/auth/sysUser/getPage',                                         //用户列表
    USER_ADD:'/hotel/auth/sysUser/create',                                           //用户新增
    USER_MODIFY:'/hotel/auth/sysUser/modify',                                        //用户修改
    USER_DELETE:'/hotel/auth/sysUser/delete',                                        //用户删除
    USER_RE_PASSWORD:'/hotel/auth/sysUser/resetPassword',                            //重置密码
    PERMISSION_LIST:'/hotel/auth/sysRole/getPermissionList',                         //获取权限列表
    SYSUSER_LIST:'/hotel/auth/sysUser/getList',                                      //获取维保单位维修人员
    USER_COUNT:'/hotel/auth/sysUser/taskCount',                                      //人员工单统计

    ROLE_SELECT:'/hotel/auth/sysRole/getList',                                       //角色下拉
    ROLE_LIST:'/hotel/auth/sysRole/getPage',                                         //角色列表
    ROLE_ADD:'/hotel/auth/sysRole/create',                                           //角色添加
    ROLE_MODIFY:'/hotel/auth/sysRole/modify',                                        //角色修改
    ROLE_DELETE:'/hotel/auth/sysRole/delete',                                        //角色删除

    BOWNER_SELECT:'/hotel/baseinfo/bOwner/getList',                                  //业主单位下拉列表
    BOWNER_LIST:'/hotel/baseinfo/bOwner/getPage',                                    //业主单位列表
    BOWNER_ADD:'/hotel/baseinfo/bOwner/create',                                      //业主单位新增
    BOWNER_MODIFY:'/hotel/baseinfo/bOwner/modify',                                   //业主单位修改
    BOWNER_DELETE:'/hotel/baseinfo/bOwner/delete',                                   //业主单位删除

    BMAINTEN_SELECT:'/hotel/baseinfo/bMaintenance/getList',                          //维保单位下拉列表
    BMAINTEN_LIST:'/hotel/baseinfo/bMaintenance/getPage',                            //维保单位列表
    BMAINTEN_ADD:'/hotel/baseinfo/bMaintenance/create',                              //维保单位新增
    BMAINTEN_MODIFY:'/hotel/baseinfo/bMaintenance/modify',                           //维保单位修改
    BMAINTEN_DELETE:'/hotel/baseinfo/bMaintenance/delete',                           //维保单位删除

    DEPARTMENT_SELECT:'/hotel/auth/sysDepartment/getList',                           //部门下拉
    DEPARTMENT_LIST:'/hotel/auth/sysDepartment/getPage',                             //部门列表
    DEPARTMENT_ADD:'/hotel/auth/sysDepartment/create',                               //部门添加
    DEPARTMENT_MODIFY:'/hotel/auth/sysDepartment/modify',                            //部门修改
    DEPARTMENT_DELETE:'/hotel/auth/sysDepartment/delete',                            //部门删除

    BDEVICE_SELECT:'/hotel/baseinfo/bDevice/getList',                                //设备下拉列表
    BDEVICE_LIST:'/hotel/baseinfo/bDevice/getPage',                                  //设备列表
    BDEVICE_ADD:'/hotel/baseinfo/bDevice/create',                                    //设备添加
    BDEVICE_MODIFY:'/hotel/baseinfo/bDevice/modify',                                 //设备修改
    BDEVICE_DELETE:'/hotel/baseinfo/bDevice/delete',                                 //设备删除
    BDEVICE_DOWN:'/hotel/baseinfo/bDevice/getTemplate',                              //模板下载
    BDEVICE_UPDOLE:'/hotel/baseinfo/bDevice/importDevice',                           //设备导入
    BDEVICE_COUNT:'/hotel/baseinfo/bDevice/taskCount',                               //设备统计

    BMAINTEN_PLAN_SELECT:'/hotel/baseinfo/bMaintainPlan/getList',                    //保养计划下拉列表
    BMAINTEN_PLAN_LIST:'/hotel/baseinfo/bMaintainPlan/getPage',                      //保养计划列表
    BMAINTEN_PLAN_ADD:'/hotel/baseinfo/bMaintainPlan/create',                        //保养计划新增
    BMAINTEN_PLAN_MODIFY:'/hotel/baseinfo/bMaintainPlan/modify',                     //保养计划修改
    BMAINTEN_PLAN_DELETE:'/hotel/baseinfo/bMaintainPlan/delete',                     //保养计划删除

    BMAINTEN_PROJECT_SELECT:'/hotel/baseinfo/bMaintainProject/getList',              //保养项目下拉列表
    BMAINTEN_PROJECT_LIST:'/hotel/baseinfo/bMaintainProject/getPage',                //保养项目列表
    BMAINTEN_PROJECT_ADD:'/hotel/baseinfo/bMaintainProject/create',                  //保养项目新增
    BMAINTEN_PROJECT_MODIFY:'/hotel/baseinfo/bMaintainProject/modify',               //保养项目修改
    BMAINTEN_PROJECT_DELETE:'/hotel/baseinfo/bMaintainProject/delete',               //保养项目删除

    BREPAIRTASK_CREATE:'/hotel/operate/bRepairTask/create',                          //新增故障工单信息-故障报修
    BREPAIRTASK_OWNLIST:'/hotel/operate/bRepairTask/getOwnList',                     //获取个人故障工单列表
    BREPAIRTASK_GETPAGE:'/hotel/operate/bRepairTask/getPage',                        //故障工单历史列表-分页
    BREPAIRTASK_GETPAGE1:'/hotel/operate/bRepairTask/getFixPage',                    //故障工单历史列表-分页
    BREPAIRTASK_GETLIST:'/hotel/operate/bRepairTask/getList',                        //故障工单列表
    BREPAIRTASK_MODIFY:'/hotel/operate/bRepairTask/modify',                          //故障工单信息修改
    BREPAIRTASK_DELETE:'/hotel/operate/bRepairTask/delete',                          //故障工单撤回
    BREPAIRTASK_RECEIVE:'/hotel/operate/bRepairTask/receive',                        //接单
    BREPAIRTASK_COMPLETE:'/hotel/operate/bRepairTask/complete',                      //完成
    BREPAIRTASK_CONFIRM:'/hotel/operate/bRepairTask/confirm',                        //确认
    BREPAIRTASK_DROP:'/hotel/operate/bRepairTask/drop',                              //工单误抢退单
    BREPAIRTASK_REASON:'/hotel/operate/bRepairTask/reason',                          //延迟原因
    SYSDICT_REASON:'/hotel/operate/sysDict/getList',                                 //获取延迟原因

    BMAINTAINTASK_CREATE:'/hotel/operate/bMaintainTask/create',                      //新增保养工单信息-保养预约
    BMAINTAINTASK_OWNLIST:'/hotel/operate/bMaintainTask/getOwnList',                 //获取个人保养工单列表
    BMAINTAINTASK_PAGE:'/hotel/operate/bMaintainTask/getPage',                       //保养工单历史列表-分页
    BMAINTAINTASK_PAGE1:'/hotel/operate/bMaintainTask/getFixPage',                   //保养工单历史列表-分页
    BMAINTAINTASK_LIST:'/hotel/operate/bMaintainTask/getList',                       //保养工单列表
    BMAINTAINTASK_MODIFY:'/hotel/operate/bMaintainTask/modify',                      //保养工单信息修改
    BMAINTAINTASK_DELETE:'/hotel/operate/bMaintainTask/delete',                      //保养工单信息撤回
    BMAINTAINTASK_RECEIVE:'/hotel/operate/bMaintainTask/receive',                    //接单
    BMAINTAINTASK_CONFIRM:'/hotel/operate/bMaintainTask/confirm',                    //确认
    BMAINTAINTASK_COMPLETE:'/hotel/operate/bMaintainTask/complete',                  //完成
    BMAINTAINTASK_REASON:'/hotel/operate/bMaintainTask/reason',                      //延迟原因
    BMAINTAINTASK_DROP:'/hotel/operate/bMaintainTask/drop',                          //工单误抢退单

    PARTS_ADD:'/hotel/baseinfo/bParts/create',                                       //新增配件信息
    PARTS_DETELE:'/hotel/baseinfo/bParts/delete',                                    //删除配件信息
    PARTS_LIST:'/hotel/baseinfo/bParts/getPage',                                     //配件列表
    PARTS_GET_TEMP:'/hotel/baseinfo/bParts/getTemplate',                             //获取模板
    PARTS_IMPORT:'/hotel/baseinfo/bParts/importParts',                               //配件导入
    PARTS_MODIFY:'/hotel/baseinfo/bParts/modify',                                    //配件修改
}

module.exports = URL



// WEBPACK FOOTER //
// ./src/utils/api.js